import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import LiveVideosContainer from '../containers/liveVideosContainer';
import MyVideosContainer from '../containers/myVideosContainer';
import VideoContainer from '../containers/videoContainer';
import VideosContainer from '../containers/videosContainer';
import VideosTopicContainer from '../containers/videosTopicContainer';
import VideosUnauthorizedContainer from '../containers/videosUnauthorizedContainer';

export default () => (
  <>
    <Switch>
      <Route path="/student/videos/topics/:id">
        <VideosTopicContainer />
      </Route>
      <Route path="/student/videos/unauthorized" exact>
        <VideosUnauthorizedContainer isLearner />
      </Route>
      <Route path="/student/videos/my-videos">
        <MyVideosContainer />
      </Route>
      <Route path="/student/videos/:type/:id">
        <VideoContainer />
      </Route>
      <Route path="/student/videos/live">
        <LiveVideosContainer />
      </Route>
      <Route path="/student/videos">
        <VideosContainer />
      </Route>
    </Switch>
    <ReactQueryDevtools initialIsOpen={false} />
  </>
);
